<template>
  <v-card class="d-flex align-self-start" flat>
    <v-container fluid>
      <v-row dense class="mr-5">
        <v-col cols="12">
          <v-card flat>
            <v-card-title class="display-2 font-weight-black">
              Novedades
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="updates.length <= 0" class="text-center">
          <lottie-player
            v-if="true"
            src="https://assets9.lottiefiles.com/packages/lf20_dx5nwnnb.json"
            background="transparent"
            speed="1"
            style="width: 250px; height: 250px"
            loop
            autoplay
          ></lottie-player>
          <div class="display-1">Sin novedades...</div>
        </v-col>
        <v-col cols="12" v-if="updates.length > 0">
          <v-timeline dense>
            <v-timeline-item
              v-for="(update, i) in updates"
              :key="i"
              small
              class="pb-0"
            >
              <div class="py-1">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <h2>
                      {{ update.titulo }}
                    </h2>
                  </v-col>
                  <v-col cols="auto" class="pa-0" v-if="update.img">
                    <v-img
                      :src="require('@/assets/new.png')"
                      width="50"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col cols="8" align-self="center" class="py-0">
                    <div style="color: #ff0000; font-weight: bold">
                      {{ update.text }}
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <a
                      style="font-weight: bold"
                      :href="update.href"
                      target="_blank"
                    >
                      {{ update.href }}
                    </a>
                  </v-col>
                </v-row>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-col>        
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
const signalR = require("@microsoft/signalr");

export default {
  data() {
    return {
      updates: [
        {
          titulo: "ACTUALIZACIONES",
          img: false,
          text: "WhatsApp para el módulo de cabina versión 1.0 disponible, envió de texto, contenido multimedia y reenvío de mensajes al proveedor.",
          href: "",
        },
      ],
      connection: "",
    };
  },
  mounted() {
    /*this.connection.on("Receive", (data) => {
      console.log(data);
    });*/
  },
  computed: {
  },
  created() {
    //
  },
  methods: {
    SignalRConnect() {
      /*this.connection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl("https://localhost:44316/callWhatsAppApi", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .build();

      this.connection
        .start()
        .then(() => {
          console.log("Conexion exitosa");
        })
        .catch((error) => {
          console.log("No se pudo conectar", error);
        });

      console.log(this.connection.state);*/
    },
  },
};
</script>
